import { createAction, props } from '@ngrx/store';
import {
  CognitoUser,
  CognitoAuthError,
  MagicLinkResult
} from '@cpd-app/core-module/models';

export const signinWithGoogle = createAction(
  '[CognitoAuth] Signin With Google'
);

export const signInWithGoogleInProgress = createAction(
  '[CognitoAuth] Sign In With Google In Progress'
);
export const signinWithGoogleFailure = createAction(
  '[CognitoAuth] Signin With Google Failure',
  props<{ error: CognitoAuthError }>()
);

export const signinWithLinkedIn = createAction(
  '[CognitoAuth] Signin With LinkedIn'
);

export const signInWithLinkedInInProgress = createAction(
  '[CognitoAuth] Sign In With LinkedIn In Progress'
);
export const signinWithLinkedInFailure = createAction(
  '[CognitoAuth] Signin With LinkedIn Failure',
  props<{ error: CognitoAuthError }>()
);

export const signInWithMagicLink = createAction(
  '[CognitoAuth] Sign In With Magic Link',
  props<{ email: string }>()
);

export const signInWithMagicLinkSuccess = createAction(
  '[CognitoAuth] Sign In With Magic Link Success',
  props<{ result: MagicLinkResult; email: string }>()
);

export const signInWithMagicLinkFailure = createAction(
  '[CognitoAuth] Sign In With Magic Link Failure',
  props<{ error: CognitoAuthError }>()
);

export const signOut = createAction('[CognitoAuth] Sign Out');

export const signOutInProgress = createAction(
  '[CognitoAuth] Sign Out InProgress'
);

export const signOutFailure = createAction(
  '[CognitoAuth] Sign Out Failure',
  props<{ error: CognitoAuthError }>()
);

export const checkAuthenticationStatus = createAction(
  '[CognitoAuth] Check Authentication Status'
);

export const checkAuthenticationStatusSuccess = createAction(
  '[CognitoAuth] Check Authentication Status Success',
  props<{ isAuthenticated: boolean; user: CognitoUser }>()
);

export const checkAuthenticationStatusFailure = createAction(
  '[CognitoAuth] Check Authentication Status Failure',
  props<{ error: CognitoAuthError }>()
);

export const getSession = createAction('[CognitoAuth] Get Session');

export const confirmSignInWithMagicLink = createAction(
  '[CognitoAuth] Confirm SignIn With Magic Link',
  props<{ token: string; email: string }>()
);

export const confirmSignInWithMagicLinkSuccess = createAction(
  '[CognitoAuth] Confirm SignIn With Magic Link Success'
);

export const confirmSignInWithMagicLinkFailure = createAction(
  '[CognitoAuth] Confirm SignIn With Magic Link Failure',
  props<{ error: CognitoAuthError }>()
);

export const signInWithMagicLinkInNewSession = createAction(
  '[CognitoAuth] Sign In With Magic Link In New Session',
  props<{ token: string; email: string }>()
);

export const cognitoCallback = createAction('[CognitoAuth] Cognito Callback');

export const cognitoCallbackSuccess = createAction(
  '[CognitoAuth] Cognito Callback Success',
  props<{ token: string; refreshToken: string }>()
);

export const cognitoCallbackFailure = createAction(
  '[CognitoAuth] Cognito Callback Failure',
  props<{ error: CognitoAuthError }>()
);

export const saveTokenToStorage = createAction(
  '[CognitoAuth] Save Token To Storage',
  props<{ token: string; refreshToken: string }>()
);

export const deleteTokenFromStorage = createAction(
  '[CognitoAuth] Delete Token From Storage'
);
